import { CallGETAPI } from "../../../../common/services";

export const getAssignedAed = async (id) => {
    const data = await CallGETAPI("aed/assign-aed-list/" +id);
    return data?.data?.data || {};
}